import { Tooltip } from '@mui/material';
import { useIsOverflowed } from 'apps/app/src/hooks/use-is-overflowed';
import React, { useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

type VyTableCellProps = {
  value?: React.ReactNode;
  containerClassName?: string;
  className?: string;
};

export const VyTableCell: React.FC<VyTableCellProps> = ({ value = '--', className, containerClassName }) => {
  const divCellRef = useRef<HTMLDivElement>(null);
  const isDivOverflowed = useIsOverflowed(divCellRef);
  const [isHovering, setIsHovering] = useState(false);

  return (
    <Tooltip
      title={value}
      placement="top"
      arrow
      open={isDivOverflowed && isHovering}
    >
      <div
        className={twMerge('flex w-full items-center justify-center', containerClassName)}
      >
        <p
          ref={divCellRef}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          className={twMerge('truncate font-sans text-black', className)}
        >
          {value}
        </p>
      </div>
    </Tooltip>
  );
};